module.exports = __webpack_public_path__ + "img/regenerate.1afabf5c.svg";